import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {SplitText} from "gsap/SplitText";
import {ScrollSmoother} from "gsap/ScrollSmoother";
import { isMobile } from 'detect-touch-device';

let smoother;
let mm = gsap.matchMedia();

class CustomAnimation {

  init() {
    gsap.registerPlugin(ScrollTrigger, SplitText, ScrollSmoother);

    // logo color
    const sections = gsap.utils.toArray(".section");
    sections.forEach((section) => {
      ScrollTrigger.create({
        trigger: section,
        start: "top 60",
        end: "bottom 60",
        markers: false,
        onEnter: () => changeLogoColor(section.dataset.logocolor) ,
        onEnterBack: () => changeLogoColor(section.dataset.logocolor)
      });
    });

    function changeLogoColor( color ) {
      if(color === "white") {
        $('.top_logo').removeClass('logo_is_black');
        $('.top_burger').removeClass('burger_is_black');
        //$('.burger_menu').removeClass('burger_menu_is_black');
      }
      else
      {
        $('.top_logo').addClass('logo_is_black');
        $('.top_burger').addClass('burger_is_black');
        //$('.burger_menu').addClass('burger_menu_is_black');
      }
    }

    this.initSmoothScroll();
    this.initNaviAnimation();
    this.initHeaderAnimation();
    this.initHeadlineAnimation();
    this.initTextAnimation();
    this.initImageAnimation();
    this.initBackgroundAnimation();
    this.initSpacerAnimation();
    this.initFooterAnimation();
  }

  initSmoothScroll = () => {

    if (!isMobile) {
      smoother = ScrollSmoother.create({
        wrapper: '.page',
        content: ".scroll",
        smooth: 1.6, // how long (in seconds) it takes to "catch up" to the native scroll position
        effects: true, // looks for data-speed and data-lag attributes on elements
        smoothTouch: 0, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)#
        normalizeScroll: true,
        speed: 1
      });

      smoother.scrollTo(0, false);
    }
    else {
      gsap.to(window, {
        duration: 1.2,
        ease: "power4.out",
        scrollTo: {
          y: 0,
          // offsetY: 0 // ggf. Höhe eurer fixen Top-Bar berücksichtigen
        }
      });
    }
  }

  getSmoother = () => {
    return smoother;
  }

  initNaviAnimation = () => {
    let tl = gsap.timeline({});
    tl.set('.top_bar', {
      y: '-20px',
      alpha: 0,
      duration: 0
    }, 0);
    tl.to('.top_bar', {
      delay:1,
      y: 0,
      alpha: 1,
      duration: .7,
      ease: "power1.out"
    }, .8);
  }

  initHeaderAnimation = () => {

    // header image animation
    gsap.set( '.header_image', {
      rotate: 0,
      ease: "expo.out",
      scale: 1.9,//.3,
      opacity: 1,
      y: '1350px' //'20%'
    });
    gsap.to('.header_image', {
      delay: 0,
      rotate: 0,
      duration:  3,
      repeat: 0,
      ease: "expo.out",
      scale: 1,
      opacity: 1,
      y: 0
    });

    gsap.set( '.header_headline', {
      rotate: 0,
      ease: "expo.out",
      scale: .7,//.3,
      opacity: 0,
      filter: "blur(0px)"
    });
    gsap.to('.header_headline', {
      delay: .9,
      rotate: 0,
      duration:  2,
      repeat: 0,
      ease: "expo.out",
      scale: 1,
      opacity: 1,
      filter: "blur(0px)"
    });

    gsap.set( '.airbnb_stoerer', {
      scale: .7,
      opacity: 0
    });
    gsap.to('.airbnb_stoerer', {
      delay: 3,
      rotate: 0,
      duration: 1,
      repeat: 0,
      ease: "back.out(5)",
      scale: 1,
      opacity: 1
    });


    // header_scroll_arrow visibility
    gsap.to('.header_arrow_down', {
      scrollTrigger: {
        trigger: '.header',
        start: 'top 0%',
        end: '10% 5%',
        markers: false,
        scrub: true
      },
      autoAlpha: 0
    });

    mm.add("(min-width: 768px)", () => {

      gsap.to('.header_background', {
        scrollTrigger: {
          trigger: '.header_background',
          start: 'top 0',
          end: 'bottom top',
          markers: false,
          scrub: true
        },
        y: 500,
        //opacity: .8,
        scale:1.2
      });

      gsap.to('.header_headline', {
        scrollTrigger: {
          trigger: '.header',
          start: 'top 5%',
          end: 'bottom 50%',
          markers: false,
          scrub: true
        },
        y: 200
      });

    });
    mm.add("(max-width: 767px)", () => {

      gsap.to('.header_background', {
        scrollTrigger: {
          trigger: '.header_background',
          start: 'top 0',
          end: 'bottom top',
          markers: false,
          scrub: true
        },
        y: 300,
        //opacity: .8,
        scale:1.2
      });

      gsap.to('.header_headline', {
        scrollTrigger: {
          trigger: '.header_headline',
          start: 'top 40%',
          end: 'bottom -40%',
          markers: false,
          scrub: true
        },
        y: 150
      });
    });

  }

  initHeadlineAnimation = () => {

    gsap.config({ trialWarn: false });
    //console.clear();
    gsap.registerPlugin(ScrollTrigger, SplitText);
    let split = new SplitText("h1", { type: "lines" });

    function makeItHappen() {
      split.lines.forEach((target) => {
        gsap.to(target, {
          backgroundPositionX: 0,
          ease: "none",
          scrollTrigger: {
            trigger: target,
            markers: false,
            scrub: 0.5,
            start: "top 80%",
            end: "bottom 70%",
          }
        });
      });
    }

    /*
    let someDelay = gsap.delayedCall(0.2, newTriggers).pause();
    window.addEventListener("resize", () => someDelay.restart(true));

    function newTriggers() {
      ScrollTrigger.getAll().forEach((trigger) => {
        trigger.kill();
      });
      split.split();
      makeItHappen();
    }*/

    makeItHappen();
  }

  initTextAnimation = () => {

    const copyGroup = gsap.utils.toArray('.blur_animation');
    copyGroup.forEach((element) => {
      gsap.set(element, { filter: "blur(5px)", y: 25 });
      gsap.to(element, {
        filter: "blur(0px)",
        y:0,
        scrollTrigger: {
          trigger: element,
          start: "top bottom",
          end: "top 80%",
          scrub: true,
          markers: false
        }
      });
    });

    // reetkate_text
    mm.add("(min-width: 768px)", () => {
      gsap.fromTo('.reetkate_text', {
          scrollTrigger: {
            trigger: '.reetkate_text',
            start: 'top 100%',
            end: 'top 0%',
            markers: false,
            scrub: 1
          },
          y: -100
        },
        {
          scrollTrigger: {
            trigger: '.reetkate_text',
            start: 'top 100%',
            end: 'top 0%',
            markers: false,
            scrub: 1
          },
          y: 0
        });
    });

    // mobile
    mm.add("(max-width: 992px)", () => {
      gsap.fromTo('.reetkate_text', {
          scrollTrigger: {
            trigger: '.reetkate_text',
            start: 'top 100%',
            end: 'top 0%',
            markers: false,
            scrub: 1
          },
          y: -50
        },
        {
          scrollTrigger: {
            trigger: '.reetkate_text',
            start: 'top 100%',
            end: 'top 0%',
            markers: false,
            scrub: 1
          },
          y: 0
        });
    });
    // mobile
    mm.add("(max-width: 767px)", () => {
      gsap.fromTo('.reetkate_text', {
          scrollTrigger: {
            trigger: '.reetkate_text',
            start: 'top 100%',
            end: 'top 0%',
            markers: false,
            scrub: 1
          },
          y: 0
        },
        {
          scrollTrigger: {
            trigger: '.reetkate_text',
            start: 'top 100%',
            end: 'top 0%',
            markers: false,
            scrub: 1
          },
          y: 0
        });
    });

    const copyGroup2 = gsap.utils.toArray('.ausstattung_box');
    copyGroup2.forEach((element) => {
      gsap.from(element, {
        y:50,
        scrollTrigger: {
          trigger: element,
          start: "top bottom",
          end: "top 80%",
          scrub: true,
          markers: false
        }
      });
    });

    const copyGroup3 = gsap.utils.toArray('.bewertungen_caroussel');
    copyGroup3.forEach((element) => {
      gsap.from(element, {
        y:50,
        scrollTrigger: {
          trigger: element,
          start: "top bottom",
          end: "top 80%",
          scrub: true,
          markers: false
        }
      });
    });

    const copyGroup4 = gsap.utils.toArray('.button_faq');
    copyGroup4.forEach((element) => {
      gsap.from(element, {
        y:50,
        scrollTrigger: {
          trigger: element,
          start: "top bottom",
          end: "top 80%",
          scrub: true,
          markers: false
        }
      });
    });

    const copyGroup5 = gsap.utils.toArray('.faq_content');
    copyGroup5.forEach((element) => {
      gsap.from(element, {
        y:50,
        scrollTrigger: {
          trigger: element,
          start: "top bottom",
          end: "top 80%",
          scrub: true,
          markers: false
        }
      });
    });

    const copyGroup6 = gsap.utils.toArray('.faq_spacer');
    copyGroup6.forEach((element) => {
      gsap.from(element, {
        y:50,
        scrollTrigger: {
          trigger: element,
          start: "top bottom",
          end: "top 80%",
          scrub: true,
          markers: false
        }
      });
    });

  }

  initImageAnimation = () => {

    const elementGroup = gsap.utils.toArray('.image_animation');
    elementGroup.forEach((element) => {
      gsap.from(element, {
        scrollTrigger: {
          trigger: element,
          start: 'top 100%',
          end: 'top 50%',
          markers: false,
          scrub: 1
        },
        y: 50,
        alpha: 1
      });
      ScrollTrigger.refresh();
    });

    mm.add("(min-width: 768px)", () => {

      gsap.from('.faq_sky', {
        scrollTrigger: {
          trigger: '.image_holder',
          start: 'top 50%',
          end: 'center 00%',
          markers: false,
          scrub: true
        },
        y: -200,
        //opacity: .8,
        scale: 1
      });

    });
    mm.add("(max-width: 767px)", () => {

      gsap.from('.faq_sky', {
        scrollTrigger: {
          trigger: '.image_holder',
          start: 'top 100%',
          end: 'center 50%',
          markers: false,
          scrub: true
        },
        y: -150,
        //opacity: .8,
        scale: 1
      });
    });
  }

  initBackgroundAnimation = () => {

    mm.add("(min-width: 768px)", () => {
      gsap.from('.background_ausstattung', {
        scrollTrigger: {
          trigger: '.ausstattung',
          start: 'top bottom',
          end: 'top center',
          markers: false,
          scrub: true
        },
        y: 0,
        scale: .8
      });

      gsap.from('.background_umgebung', {
        scrollTrigger: {
          trigger: '.umgebung',
          start: 'top bottom',
          end: 'top center',
          markers: false,
          scrub: true
        },
        y: 0,
        scale: .8
      });
    });

    mm.add("(max-width: 767px)", () => {
      gsap.from('.background_ausstattung', {
        scrollTrigger: {
          trigger: '.ausstattung',
          start: 'top bottom',
          end: 'top center',
          markers: false,
          scrub: true
        },
        y: 0,
        scale: .9
      });

      gsap.from('.background_umgebung', {
        scrollTrigger: {
          trigger: '.umgebung',
          start: 'top bottom',
          end: 'top center',
          markers: false,
          scrub: true
        },
        y: 0,
        scale: .9
      });
    });


  }

  initSpacerAnimation = () => {

    const serviceSpacer = gsap.utils.toArray('.line_top');
    serviceSpacer.forEach((element) => {
      gsap.fromTo(element, {
          scrollTrigger: {
            trigger: element,
            start: 'top 100%',
            end: 'top 80%',
            markers: false,
            scrub: 1
          },
          width: 1
        },
        {
          scrollTrigger: {
            trigger: element,
            start: 'top 100%',
            end: 'top 80%',
            markers: false,
            scrub: 1
          },
          width: '100%',
        });

    });
  }

  initFooterAnimation = () => {

    gsap.from('.background_kontakt', {
      scrollTrigger: {
        trigger: '.background_kontakt',
        start: 'top bottom',
        end: 'top center',
        markers: false,
        scrub: true
      },
      y: 0,
      scale:.9
    });


    // Airbnb-Störer ausblenden, wenn der Kontaktbereich erreicht wird
    ScrollTrigger.create({
      trigger: '.kontakt',
      start: 'top bottom',      // sobald Kontakt unten in den Viewport kommt
      end: 'top center',        // bis der Kontakt "tiefer" hinein scrollt
      markers: false,
      onEnter: () => gsap.to('.airbnb_stoerer', { autoAlpha: 0, duration: 0.3, overwrite: 'auto' }),
      onEnterBack: () => {},    // nicht nötig, übernimmt onLeaveBack
      onLeaveBack: () => gsap.to('.airbnb_stoerer', { autoAlpha: 1, duration: 0.3, overwrite: 'auto' })
    });

  }
}

export default CustomAnimation;
